import * as React from "react";

import { IUser, IAddProps } from "../types";

import Form from "./Form";

export default class Add extends React.Component<IAddProps> {
  onSubmit = async (values: IUser) => {
    await this.props.add(values);
    this.props.close();
  };

  onDelete = async (values: IUser) => {
    // not needed here
  };

  render() {
    return (
      <Form
        id="new"
        initialValues={{
          email: "",
          roles: [],
          userProfileVisibilities: [],
          localContentRoles: [],
          localUserRoles: [],
        }}
        onSubmit={this.onSubmit}
        onDelete={this.onDelete}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Users/components/New.tsx